import React from 'react';
import T from './EditableText';
import HeroPicture from './HeroPicture';

/**
 * Seitenkopf der Unterseiten: dunkle Fläche, links Text, rechts Foto —
 * dieselbe Bauart wie der Kopf der Startseite (`.hx-hero`), nur niedriger.
 */
const PageHero: React.FC<{
  eyebrowKey: string;
  titleKey: string;
  accentKey?: string;
  image: { src: string; alt: string; width: number; height: number; position?: string };
  /** Breadcrumb o. Ä. über der Fläche. */
  above?: React.ReactNode;
  children?: React.ReactNode;
}> = ({ eyebrowKey, titleKey, accentKey, image, above, children }) => (
  <section className="shell hx-hero-wrap">
    {above}
    <div className="hx-hero hx-hero--page">
      <div className="hx-hero__body">
        <span className="eyebrow eyebrow--on-image">
          <T k={eyebrowKey} />
        </span>
        <h1 className="h-page hx-hero__title">
          <T k={titleKey} />
          {accentKey && (
            <>
              {' '}
              <span className="accent">
                <T k={accentKey} />
              </span>
            </>
          )}
        </h1>
        {children}
      </div>
      <div className="hx-hero__media">
        <HeroPicture
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          style={image.position ? { objectPosition: image.position } : undefined}
        />
      </div>
    </div>
  </section>
);

export default PageHero;
